export default "__VITE_ASSET__CC998Tvf__"